// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".workplace-todos__time-cell{display:block}", "",{"version":3,"sources":["webpack://./client/modules/structure/shiftPlanner/components/workplaceTodos/workplaceTodos.container.css"],"names":[],"mappings":"AAAA,4BACC,aACD","sourcesContent":[".workplace-todos__time-cell {\n\tdisplay: block;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
